window.__EP_SETTINGS__ = {
  BASE_URL_API: 'https://epayment-dev.one-line.com/api',
  API_KEY: '36a68602d03d196119464906ef85ae7a',
  SOCKET_URL: 'wss://epayment-dev.one-line.com/api/ws/',

  ENDPOINTS: {
    GET_SETTINGS: '/v1/settings/country/{{ country }}',
    GENERATE_ACCESS_TOKEN: '/v1/authentication/generateAccessToken',
    CREATE_PO: '/v1/purchaseOrders',
    GET_PO_DETAILS: '/v1/purchaseOrders/{{ poUid }}',
    CREATE_PAYMENT_TXN: '/v1/paymentTransactions',
    RETRY_PAYMENT_TXN: '/v1/paymentTransactions/retry',
    UPDATE_TXN_STATUS: '/v1/paymentTransactions/{{ transactionUid }}/updateTransactionStatus'
  },

  STATIC_CONTENT: {
    TERM_OF_USE_EN_SG: 'https://epayment-dev.one-line.com/public/files/terms-of-use.en-US.html',
    TERM_OF_USE_EN_HK: 'https://epayment-dev.one-line.com/public/files/terms-of-use.en-US.html',
    TERM_OF_USE_EN_ID: 'https://epayment-dev.one-line.com/public/files/terms-of-use.en-US.html',
    TERM_OF_USE_EN_TH: 'https://epayment-dev.one-line.com/public/files/terms-of-use.en-TH.html'
  }
}
